import React from 'react';

export interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'regular' | 'small';
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit';
}

const Button = ({
  variant,
  size,
  children,
  disabled,
  onClick,
  className,
  type = 'button',
}: ButtonProps) => {
  const createClassNames = () => {
    let classNames = `inline-block text-brand-grey-4 focus-visible:outline focus-visible:outline-offset-3 focus-visible:outline-3 focus-visible:outline-text-light ${className}`;

    if (variant === 'primary' || variant === undefined) {
      classNames +=
        ' rounded-full bg-accent-primary-normal hover:bg-accent-primary-dark active:bg-brand-yellow-3 disabled:bg-neutral-grey-200 disabled:text-neutral-grey-300';
    } else if (variant === 'secondary') {
      classNames +=
        ' rounded-full bg-neutral-grey-100 hover:bg-neutral-grey-200 active:bg-neutral-grey-300 disabled:bg-neutral-grey-200 disabled:text-neutral-grey-300';
    }

    if (size === 'regular' || size === undefined) {
      classNames += ' px-6 py-3.75 text-buttonlabell';
    } else if (size === 'small') {
      classNames += ' px-5 py-3.5 text-buttonlabelm';
    }

    return classNames;
  };

  return (
    <button
      tabIndex={0}
      className={`${createClassNames()} ${className}`}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;
